import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { FiTrash2, FiInbox } from 'react-icons/fi';

const AlertsPanel = ({
    adminAlerts,
    unreadAlerts,
    markAlertAsRead,
    formatFirestoreTimestamp,
    clearAllAlerts,
    deleteSingleAlert
}) => {
    const [showClearModal, setShowClearModal] = useState(false);
    const [alertToDelete, setAlertToDelete] = useState(null);
    const { isDarkMode } = useTheme();

    const handleClearAllAlerts = () => {
        clearAllAlerts();
        setShowClearModal(false);
    };

    const handleDeleteSingleAlert = (alert) => {
        setAlertToDelete(alert);
    };

    const confirmDeleteSingleAlert = () => {
        if (alertToDelete) {
            deleteSingleAlert(alertToDelete.id);
            setAlertToDelete(null);
        }
    };

    return (
        <div className="space-y-6">
            {/* Modal de Confirmação para Limpar Todos os Alertas */}
            {showClearModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg p-6 w-96`}>
                        <h3 className={`text-lg font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'} flex items-center gap-2`}>
                            <FiTrash2 className="w-5 h-5" />
                            Limpar Todos os Alertas
                        </h3>

                        <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'} mb-6`}>
                            Tem certeza que deseja limpar todos os alertas? Esta ação não pode ser desfeita.
                        </p>

                        <div className="flex justify-end space-x-3">
                            <button
                                onClick={() => setShowClearModal(false)}
                                className={`px-4 py-2 ${isDarkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-800'}`}
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleClearAllAlerts}
                                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                            >
                                Limpar Tudo
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Confirmação para Limpar Alerta Individual */}
            {alertToDelete && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg p-6 w-96`}>
                        <h3 className={`text-lg font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'} flex items-center gap-2`}>
                            <FiTrash2 className="w-5 h-5" />
                            Deletar Alerta
                        </h3>

                        <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'} mb-4`}>
                            Tem certeza que deseja deletar o alerta "{alertToDelete.title}"?
                        </p>

                        <div className={`${isDarkMode ? 'bg-yellow-900 border-yellow-600' : 'bg-yellow-50 border-yellow-400'} border-l-4 p-4 mb-4`}>
                            <p className={`text-sm ${isDarkMode ? 'text-yellow-300' : 'text-yellow-700'}`}>
                                <strong>Atenção:</strong> Esta ação não pode ser desfeita.
                            </p>
                        </div>

                        <div className="flex justify-end space-x-3">
                            <button
                                onClick={() => setAlertToDelete(null)}
                                className={`px-4 py-2 ${isDarkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-800'}`}
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={confirmDeleteSingleAlert}
                                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                            >
                                Deletar Alerta
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* <div className="flex justify-between items-center">
                <h2 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                    Alertas {unreadAlerts > 0 && <span className="text-red-500">({unreadAlerts} não lidos)</span>}
                </h2>
                <div className="flex items-center gap-2">
                    {adminAlerts.length > 0 && (
                        <button
                            onClick={() => setShowClearModal(true)}
                            className={`px-3 py-1 ${isDarkMode ? 'bg-red-900/50 text-red-300 hover:bg-red-900' : 'bg-red-100 text-red-700 hover:bg-red-200'} rounded-lg text-sm transition-colors font-medium`}
                        >
                            🗑️ Limpar Todos
                        </button>
                    )}
                    {unreadAlerts > 0 && (
                        <button
                            onClick={() => {
                                adminAlerts.forEach(alert => {
                                    if (!alert.read) {
                                        markAlertAsRead(alert.id);
                                    }
                                });
                            }}
                            className={`px-3 py-1 ${isDarkMode ? 'bg-blue-900/50 text-blue-300 hover:bg-blue-900' : 'bg-blue-100 text-blue-700 hover:bg-blue-200'} rounded-lg text-sm transition-colors`}
                        >
                            Marcar todos como lidos
                        </button>
                    )}
                </div>
            </div> */}

            <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'} p-6 rounded-xl shadow-sm border`}>
                {adminAlerts.length > 0 ? (
                    <div className="space-y-4">
                        {adminAlerts.map(alert => (
                            <div
                                key={alert.id}
                                className={`p-4 rounded-lg border-l-4 ${alert.read
                                    ? isDarkMode 
                                        ? 'bg-gray-700/50 border-gray-500' 
                                        : 'bg-gray-50 border-gray-300'
                                    : isDarkMode
                                    ? 'bg-blue-900/20 border-blue-400'
                                    : 'bg-blue-50 border-blue-500'
                                    } transition-all hover:shadow-md`}
                            >
                                <div className="flex justify-between items-start">
                                    <div className="flex-1">
                                        <div className="flex items-center gap-2 mb-2">
                                            <h3 className={`font-semibold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>{alert.title}</h3>
                                            {!alert.read && (
                                                <span className="bg-blue-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                                                    !
                                                </span>
                                            )}
                                        </div>
                                        <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'} mb-3`}>{alert.message}</p>
                                        <div className="flex flex-wrap gap-4 mt-2">
                                            {alert.createdAt && (
                                                <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                    Enviado: {formatFirestoreTimestamp(alert.createdAt)}
                                                </p>
                                            )}
                                            {alert.expiresAt && (
                                                <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                                                    Expira: {formatFirestoreTimestamp(alert.expiresAt)}
                                                </p>
                                            )}
                                            {alert.read && alert.readAt && (
                                                <p className={`text-xs ${isDarkMode ? 'text-green-400' : 'text-green-500'}`}>
                                                    Lido: {formatFirestoreTimestamp(alert.readAt)}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex flex-col items-end gap-2">
                                        {alert.priority === 'high' && (
                                            <span className={`${isDarkMode ? 'bg-red-900 text-red-300' : 'bg-red-100 text-red-800'} text-xs font-medium px-2 py-1 rounded`}>
                                                Urgente
                                            </span>
                                        )}
                                        <button
                                            onClick={() => handleDeleteSingleAlert(alert)}
                                            className={`${isDarkMode ? 'text-red-400 hover:text-red-300' : 'text-red-500 hover:text-red-700'} text-sm font-medium p-1`}
                                            title="Deletar este alerta"
                                        >
                                            <FiTrash2 className="w-4 h-4" />
                                        </button>
                                    </div>
                                </div>
                                <div className={`flex justify-between items-center mt-3 pt-3 ${isDarkMode ? 'border-gray-600' : 'border-gray-200'} border-t`}>
                                    {!alert.read && (
                                        <button
                                            onClick={() => markAlertAsRead(alert.id)}
                                            className={`${isDarkMode ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-800'} text-sm font-medium`}
                                        >
                                            Marcar como lido
                                        </button>
                                    )}
                                    <span className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                                        ID: {alert.id.substring(0, 8)}...
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-10">
                        <FiInbox className="mx-auto h-16 w-16 text-gray-400 mb-3" />
                        <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-500'}`}>Nenhum alerta no momento.</p>
                        <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-400'} text-sm mt-1`}>Os administradores enviarão alertas importantes aqui.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AlertsPanel;